import * as React from "react";
const SvgLogin = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: props.size || "1em",
    height: props.size || "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ...props
  },
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement("path", { d: "m8.5 1-.089.008A.5.5 0 0 0 8.5 2h5l.09.008A.5.5 0 0 1 14 2.5v11l-.008.09a.5.5 0 0 1-.492.41h-5l-.089.008A.5.5 0 0 0 8.5 15h5l.145-.007A1.5 1.5 0 0 0 15 13.5v-11l-.007-.145A1.5 1.5 0 0 0 13.5 1h-5Zm-.222 2.992a.502.502 0 0 0 .033.707L11.387 7.5H1.5l-.09.008a.5.5 0 0 0 .09.992h9.837L8.31 11.282l-.061.067a.5.5 0 0 0 .737.669l3.92-3.603.073-.08a.6.6 0 0 0-.037-.768l-.038-.037-3.919-3.57-.072-.055a.502.502 0 0 0-.635.087Z" })
);
const SvgLogin$1 = SvgLogin;
export {
  SvgLogin$1 as default
};
